import { all, takeLatest } from "redux-saga/effects";
import {
  ORDER_LIST,
  DETAIL_ORDER,
  UPDATE_ORDER,
  DELETE_ORDER,
  SYNC_ORDER,
  ORDEREMAILLIST,
  ORDEREMAIDELETE,
  ORDEREMAILCREATE,
  ORDEREMAILDETAIL,
  CAPTURESNAPFINANCE,
} from "../actions/order.actions.types";
import httpClient from "../services/http.client";
import { orderSlice } from "../slices/order";
import * as Effects from "redux-saga/effects";
import { errorMessage, successMessage } from "../../utilities/notification";
import { appslice } from "../slices/app";

const call = Effects.call;

function* getOrderList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "orders/list",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(orderSlice.actions.setOrderList(result.data?.orders));
      callback({ success: true, data: result.data });
    }
  }
}

function* orderEmailList({ payload: { data, callback } }) {
  const payload = {
    method: "get",
    url: "order-emails/list",
    params: data,
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* detailOrder({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `orders/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(orderSlice.actions.detailOrder(result.data?.order));
      callback({ success: true, data: result.data });
    }
  }
}

function* orderEmailDetail({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `order-emails/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* updateOrder({ payload: { id, data, callback } }) {
  const payload = {
    method: "put",
    url: `orders/status/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteOrder({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `orders/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(orderSlice.actions.deleteOrder(id));
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}
function* orderEmailDelete({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `order-emails/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* syncOrder({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: `orders/netsuite-sync`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });
  if (error) {
    errorMessage(error.message);
    callback({ success: false, data: null });
  } else {
    successMessage(result.message);
    callback({ success: true, data: result.data });
  }
}

function* orderEmailCreate({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "order-emails",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* captureSnapFinance({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "orders/capture",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Order() {
  yield all([
    takeLatest(ORDER_LIST, getOrderList),
    takeLatest(DETAIL_ORDER, detailOrder),
    takeLatest(UPDATE_ORDER, updateOrder),
    takeLatest(DELETE_ORDER, deleteOrder),
    takeLatest(ORDEREMAIDELETE, orderEmailDelete),
    takeLatest(SYNC_ORDER, syncOrder),
    takeLatest(ORDEREMAILCREATE, orderEmailCreate),
    takeLatest(ORDEREMAILDETAIL, orderEmailDetail),
    takeLatest(ORDEREMAILLIST, orderEmailList),
    takeLatest(CAPTURESNAPFINANCE, captureSnapFinance),
  ]);
}

export default Order;
